import React, { useState, useEffect, useRef,Component,createRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { CSVLink, CSVDownload } from 'react-csv'
import {numberWithCommas} from '../../../utils/helpers'

import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, Upload,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    LoadingOutlined
} from '@ant-design/icons';





import moment from 'moment'



const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

// console.log(ClassicEditor.builtinPlugins.map( plugin => plugin.pluginName ));


const Index = ({values , weighted_exchange}) => { 
    
    const dispatch = useDispatch()    
    const csvlinkRef = createRef()
    const { } = useSelector(
      state => ({
      
      }),
      shallowEqual
    )

    const [loading, setLoading] = useState(false)
 

    const [formattedItems, setFormattedItems] = useState([])

    useEffect(() => {
      // console.log('values',values)
      var itms = values.audited_items
      if(itms.length >0){
        exportOrders(itms)
      }
    }, [values])
    useEffect(() => {
      if(formattedItems.length > 0 && loading){
        // console.log(formattedItems)
        setLoading(false)
      }
    }, [formattedItems])




    const exportOrders = (items) =>{
      setLoading(true)
      
      var new_things = []

      items.map(thing =>{
        var difference = ( parseFloat(thing.new_count) - parseFloat(thing.old_count))     
        var peso_diff = 0
        if(thing.regionalization == 'local'){
           peso_diff = parseFloat(difference)*parseFloat(thing.cost_peso)    
        }else{
          if(thing.cost_rmb){
            peso_diff = parseFloat(difference)*parseFloat(thing.cost_rmb)*parseFloat(weighted_exchange)
          }
   
        }
      
        var percent_diff = (difference/parseFloat(thing.old_count))*100

        var n_thing ={
          ...thing,
          qty_diff:numberWithCommas(difference.toFixed(3)),
          percent_diff:numberWithCommas(percent_diff.toFixed(3)),
          peso_diff:numberWithCommas(peso_diff.toFixed(2)),
        }

        new_things.push(n_thing)
      })

      new_things.sort((a, b) => {
        return a.category_name.localeCompare(b.category_name);
      });

      setFormattedItems(new_things)

    }   
   


    const headers = [
      { label: "category", key: "category_name" },
      { label: "product", key: "name" },
      { label: "regionalization", key: "regionalization" },
      { label: "cost peso", key: "cost_peso" },
      { label: "unit", key: "unit" },

      { label: "old count", key: "old_count" },
      { label: "new count", key: "new_count" },  
      { label: "qty diff", key: "qty_diff" },      

      
      { label: "percent diff", key: "percent_diff" },  
      { label: "peso diff", key: "peso_diff" },  
      { label: "peso val", key: "peso_val" },  

 
   
    ];

    const simualteClick = () =>{

      if(formattedItems.length > 0 && !loading){
        setLoading(false)
        csvlinkRef.current.click()
      }


    }   


    return ( 
      <>

      <div style={{display:'hidden'}} >        
        <CSVLink  data={formattedItems} filename={`${values.branch_name} - audit - ${moment().format('LL')}.csv`}  target="_blank" headers={headers}   
    
        > 
          <div ref={csvlinkRef} style={{display:'hidden'}}></div></CSVLink>
      </div>

      <Button onClick={()=>{simualteClick()}} disabled={values.length < 1} style={{marginRight:'1rem'}} type={'primary'} loading={loading}>Export CSV</Button>

      </>
     )
}
  
export default Index
  